module.exports = __webpack_public_path__ + "static/media/oval4.f92396fe.svg";